
// @ts-ignore
import * as React from "react";
import { gql, useQuery } from "@apollo/client";

import {
  // AdminAdmins,
  FindAdminAdminsQueryQuery
} from "../../../../schemaTypes";

export const findAdminAdminsQuery = gql`
  query FindAdminAdminsQuery {
    findAdminAdmins {
      id
      firstname
      lastname
      email
      phone
      shortId
      createdAt
      updatedAt
    }
  }
`;

export function useFindAdminAdmins() {
  const { data, loading } = useQuery<FindAdminAdminsQueryQuery>(findAdminAdminsQuery);

  return {
    adminAdmins: data?.findAdminAdmins ?? [],
    loading
  };
}
